// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2o1xs","bigColWidth":"Table_bigColWidth__39DH2","biggerColWidth":"Table_biggerColWidth__1a59A","row":"Table_row__3tz-P","col":"Table_col__F8Ryz"};